import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { ROUTES } from './app.routes';

import { AppLoadModule } from './app-load/app-load.module';
import { LayoutsModule } from './common/layouts/layouts.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { CustomersModule } from './customer/customer.module';
import { VendorModule } from './vendor/vendor.module';
import { AdminModule } from './admin/admin.module';
import { ProductsModule } from './product/product.module';
import { InvoicesModule } from './invoices/invoices.module';
import { QuickBooksModule } from './quickbooks/quickbooks.module';
import { ReportModule } from './report/report.module';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        LayoutsModule,
        AppLoadModule,
        CoreModule.forRoot(),
        RouterModule.forRoot(ROUTES, {}),
        SharedModule,
        AdminModule,
        CustomersModule,
        InvoicesModule,
        ProductsModule,
        VendorModule,
        QuickBooksModule,
        ReportModule
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
